import React from "react";
import { Link } from "react-router-dom";
import { withRouter } from "./_shared/withRouter";

const Home = () => {
  return (
    <div>
      <h1>
        <Link to={"/superadmin/login"}>Super Admin Login</Link>
      </h1>
      <h1>
        <Link to={"/admin/login"}>Admin Login</Link>
      </h1>
      <h1>
        <Link to={"/user/login"}>User Login</Link>
      </h1>
    </div>
  );
};

export default withRouter(Home);
